export default __webpack_public_path__ + "static/Group-1254-120c90267c6f07cfe1f0aa7e8c7b4053.png";